import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;

const TrainSkeletonLoader = ({ count = 6 }) => {
  const [columnCount, setColumnCount] = useState(5);

  useEffect(() => {
    const updateLayout = () => {
      const isMobile = window.innerWidth <= 768;
      const isTable = window.innerWidth <= 950;
      const isDesktop = window.innerWidth <= 1224;

      // Use same responsive logic as Train component
      let columns;
      if (isMobile) {
        columns = 1;
      } else if (isTable) {
        columns = 3;
      } else if (isDesktop) {
        columns = 4;
      } else {
        columns = 5;
      }

      setColumnCount(columns);
    };

    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  const allItems = Array.from({ length: count }, (_, i) => i);

  return (
    <TrainContainer>
      {Array.from({ length: columnCount }).map((_, colIndex) => (
        <Column key={colIndex}>
          {allItems
            .filter((_, i) => i % columnCount === colIndex)
            .map((index) => (
              <SkeletonItem key={index}>
                <SkeletonThumbnail />
              </SkeletonItem>
            ))}
        </Column>
      ))}
    </TrainContainer>
  );
};

export default TrainSkeletonLoader;

const TrainContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;

  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
  @media (max-width: 480px) {
    justify-content: center;
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
`;

const SkeletonItem = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1.335;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const SkeletonThumbnail = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #152a47 0px, #23406a 40px, #152a47 80px);
  background-size: 468px 100%;
  animation:
    ${shimmer} 1.5s infinite linear,
    ${pulse} 2s infinite ease-in-out;
  border-radius: 12px;
`;
